<template>
    <section id="login-form" class="container">
        <div class="row mb-3">
            <div class="col-md-10">
                <h1>Sorry, this service is currently unavailable</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-md-10">
                <p
                    class="lead"
                >We’re making improvements to the Film Permits online application system, based on feedback from our customers. This service will be unavailable until August 24, 2019.</p>
                <p class="lead">
                    Please submit your application using the
                    <a
                        href="https://web.mississauga.ca/publication/location-filming-permit-application/"
                    >PDF Film Permit Application</a> .
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Maintenance"
};
</script>